/***
 *
 *   HOME LAYOUT
 *   Main website layout
 *
 **********/

import { HomeNav, useLocation } from "components/lib";
import { Fragment } from "react";

export function HomeLayout(props) {
  const location = useLocation();
  const transparent = location?.pathname === "/" ? true : false;

  return (
    <Fragment>
      <main className="home">
        <HomeNav transparent={transparent} />
        {<props.children {...props.data} />}
      </main>
    </Fragment>
  );
}
